export default {"src":"/_next/static/media/switch_org.cce63c97.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};